import { ChakraV3 } from '@piccolohealth/ui';
import { P } from '@piccolohealth/util';
import React from 'react';
import { useFieldArray, useWatch } from 'react-hook-form';
import { FaPlus, FaTimes } from 'react-icons/fa';
import { HookedFormField } from './HookedFormField';
import { HookedTextArea } from './HookedTextArea';

interface Props {
  name: string;
}

export const HookedAbcTemplates = (props: Props) => {
  const { name } = props;
  const { fields, append, remove } = useFieldArray({
    name,
  });

  const templates = useWatch({
    name,
  }) as string[];

  const lastTemplate = P.last(templates);
  const isDisabled = !P.isNil(lastTemplate) && P.isEmptyString(lastTemplate);

  const addTemplate = () => {
    append('');
  };

  const removeTemplate = (index: number) => {
    remove(index);
  };

  const items = P.run(() => {
    if (P.isEmpty(templates)) {
      return (
        <ChakraV3.Text fontSize='sm' color='secondary'>
          No templates
        </ChakraV3.Text>
      );
    }

    return fields.map((template, index) => (
      <HookedFormField key={template.id} name={`${name}[${index}]`}>
        <ChakraV3.HStack>
          <HookedTextArea
            name={`${name}[${index}]`}
            placeholder='Enter a template...'
            rows={1}
            autoresize
          />
          <ChakraV3.IconButton
            aria-label='Remove template'
            onClick={() => removeTemplate(index)}
            variant='ghost'
            size='sm'
          >
            <FaTimes />
          </ChakraV3.IconButton>
        </ChakraV3.HStack>
      </HookedFormField>
    ));
  });

  return (
    <ChakraV3.Stack>
      {items}
      <ChakraV3.Button onClick={addTemplate} size='sm' disabled={isDisabled} variant='subtle'>
        <FaPlus />
        Add template
      </ChakraV3.Button>
    </ChakraV3.Stack>
  );
};
